// extracted by mini-css-extract-plugin
export var container = "_ik-1";
export var editor = "_ik-2";
export var resizable = "_ik-3";
export var wrapper = "_ik-0";